import z from 'zod';
export const BUSINESS_LAW = 'business_law';
export const FORMATIONS = 'formations';
export const LABOR_LAW = 'labor_law';
export const LAW_TYPES = {
    BUSINESS_LAW: BUSINESS_LAW,
    FORMATIONS: FORMATIONS,
    LABOR_LAW: LABOR_LAW,
};
export const lawTypeValue = z.enum([
    BUSINESS_LAW,
    FORMATIONS,
    LABOR_LAW,
]);
export const lawType = (value) => lawTypeValue.parse(value);
export const isLawType = (value) => lawTypeValue.safeParse(value).success;
// Document editor / library APIs only cover law domains, not formations.
export const editorLawTypeValue = z.enum([BUSINESS_LAW, LABOR_LAW]);
export const editorLawType = (value) => editorLawTypeValue.parse(value);
export const isEditorLawType = (value) => editorLawTypeValue.safeParse(value).success;
//# sourceMappingURL=lawTypesContants.js.map